import React from 'react';
import { ExternalLink } from 'lucide-react';
import { GCalEvent } from '../../../types/types';

function formatGCalDate(isoStr: string | null): string {
  if (!isoStr) return '';
  const d = new Date(isoStr);
  const day = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  const time = d
    .toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true })
    .toUpperCase();
  return `${day} · ${time}`;
}

interface GCalEventCardProps {
  event: GCalEvent;
}

const GCalEventCard: React.FC<GCalEventCardProps> = ({ event }) => {
  return (
    <div
      style={{
        background: 'var(--color-surface)',
        borderRadius: 'var(--radius-md)',
        border: '1px solid var(--color-border)',
        boxShadow: 'var(--shadow-sm)',
        padding: '12px 14px',
        minWidth: 200,
        maxWidth: 260,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <div
        style={{
          fontSize: '0.85rem',
          fontWeight: 700,
          letterSpacing: '0.5px',
          textTransform: 'lowercase',
          color: 'var(--color-content)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {event.title}
      </div>

      {event.start_datetime && (
        <div
          style={{
            fontSize: '0.72rem',
            color: 'var(--color-content-muted)',
            letterSpacing: '0.3px',
          }}
        >
          {formatGCalDate(event.start_datetime)}
        </div>
      )}

      {event.location && (
        <div
          style={{
            fontSize: '0.72rem',
            color: 'var(--color-content-muted)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {event.location}
        </div>
      )}

      {event.link && (
        <button
          onClick={e => {
            e.stopPropagation();
            window.open(event.link, '_blank', 'noopener,noreferrer');
          }}
          style={{
            marginTop: 6,
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            padding: '5px 10px',
            borderRadius: 'var(--radius-pill)',
            border: '1px solid var(--color-primary)',
            background: 'transparent',
            color: 'var(--color-primary)',
            fontSize: '0.72rem',
            fontWeight: 600,
            letterSpacing: '0.5px',
            cursor: 'pointer',
            alignSelf: 'flex-start',
          }}
        >
          <ExternalLink size={11} />
          view event
        </button>
      )}
    </div>
  );
};

export default GCalEventCard;
